<div class="gestor-dialog">

  <!-- Header -->
  <div class="gestor-header">
    <h2 class="gestor-title">
      <mat-icon>account_balance_wallet</mat-icon>
      Gestión de Carteras
    </h2>
    <button mat-icon-button (click)="dialogRef.close()" class="close-button" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Two-column content -->
  <div class="gestor-content">

    <!-- ── Left: open / delete ── -->
    <div class="gestor-col">

      <div class="gestor-section">
        <div class="section-header">
          <mat-icon class="small-icon">folder_open</mat-icon>
          Abrir cartera existente
        </div>
        <label class="field-label">Cartera</label>
        <select class="gestor-select" [(ngModel)]="optimaseleccionada">
          <option [ngValue]="null" selected>Selecciona...</option>
          <option [ngValue]="modelo" *ngFor="let modelo of listModelo">{{ modelo.nombre }}</option>
        </select>
        <button mat-flat-button class="ccorbit action-btn" (click)="abrirCartera()">
          <mat-icon>folder_open</mat-icon>
          Abrir Cartera
        </button>
      </div>

      <div class="gestor-section">
        <div class="section-header danger-header">
          <mat-icon class="small-icon danger">delete_forever</mat-icon>
          Eliminar cartera existente
        </div>
        <label class="field-label">Cartera</label>
        <select class="gestor-select" [(ngModel)]="modeloSeleccionado">
          <option [ngValue]="null" selected>Selecciona...</option>
          <option value="{{ modelo.idcartera }}" *ngFor="let modelo of listModelo">{{ modelo.nombre }}</option>
        </select>
        <button class="action-btn danger-btn" (click)="eliminarCartera()">
          <mat-icon>delete_forever</mat-icon>
          Eliminar Cartera
        </button>
      </div>

    </div>

    <!-- ── Divider ── -->
    <div class="gestor-divider"></div>

    <!-- ── Right: create new ── -->
    <div class="gestor-col right-col">

      <div class="section-header">
        <mat-icon class="small-icon">add_circle</mat-icon>
        Crear nueva cartera
      </div>

      <div class="form-grid">

        <div class="form-row">
          <label class="field-label">Capital Inicial</label>
          <input type="number" class="gestor-input"
                 [(ngModel)]="optimalWallet.capitalinicial"
                 (ngModelChange)="calcularData()" />
        </div>

        <div class="form-row">
          <label class="field-label">Riesgo Máximo</label>
          <input type="number" class="gestor-input" [(ngModel)]="optimalWallet.riesgomaximo" />
        </div>

        <div class="form-row">
          <label class="field-label">Tipo Cuenta</label>
          <select class="gestor-select" (change)="disabledMargin($event)" [(ngModel)]="optimalWallet.tipocuenta">
            <option selected>Seleccionar</option>
            <option value="{{ type }}" *ngFor="let type of accountType">{{ type }}</option>
          </select>
        </div>

        <div class="form-row">
          <label class="field-label">Apalancamiento</label>
          <input type="number" class="gestor-input"
                 [(ngModel)]="optimalWallet.apalancamiento"
                 (ngModelChange)="calcularData()" />
        </div>

        <div class="form-row">
          <label class="field-label">Tipo Riesgo</label>
          <select class="gestor-select" [(ngModel)]="optimalWallet.tiporiesgo">
            <option selected>Selecciona</option>
            <option value="{{ type }}" *ngFor="let type of purchaseTypes">{{ type }}</option>
          </select>
        </div>

        <div class="form-row">
          <label class="field-label">Valor Riesgo</label>
          <input type="number" class="gestor-input" [(ngModel)]="optimalWallet.riesgo" />
        </div>

        <div class="form-row">
          <label class="field-label">Comisión 2/2</label>
          <input type="number" class="gestor-input" [(ngModel)]="optimalWallet.comisionbroker" />
        </div>

        <div class="form-row">
          <label class="field-label">Intervalo Val. Liquidativos</label>
          <select class="gestor-select" [(ngModel)]="optimalWallet.intervalotiempo">
            <option selected>Selecciona</option>
            <option value="{{ intervalo.idperiodo }}" *ngFor="let intervalo of intervalos">{{ intervalo.periodo }}</option>
          </select>
        </div>

        <div class="form-row">
          <label class="field-label">Stop Loss</label>
          <input type="number" class="gestor-input"
                 [(ngModel)]="optimalWallet.stopLoss" min="0.001" max="100" />
        </div>

        <div class="form-row">
          <label class="field-label">Mercados</label>
          <app-mercado-select class="gestor-select"
            [mercados]="mercados"
            placeholder="Selecciona"
            [(ngModel)]="optimalWallet.idmercado">
          </app-mercado-select>
        </div>

        <div class="form-row">
          <label class="field-label">Nombre</label>
          <input type="text" class="gestor-input" [(ngModel)]="optimalWallet.nombre" [maxlength]="maxNombreCartera" />
        </div>

      </div>

      <div class="form-footer">
        <span class="error-label" *ngIf="labelerror">{{ labelerror }}</span>
        <button mat-flat-button class="ccorbit action-btn" (click)="guardarCartera()">
          <mat-icon>add_circle</mat-icon>
          Crear Cartera
        </button>
      </div>

    </div>

  </div>
</div>
